import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { deleteCategory, getCategories } from '../store/categoryActions';

DeleteCategory.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  category: PropTypes.object,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
};

/**
 * Confirms deleting an asset category.
 *
 * Not the shared ConfirmationDialog, which dispatches this package's delete
 * action for every package that uses it.
 */
export default function DeleteCategory({ open, handleClose, category, page, rowsPerPage }) {
  const dispatch = useDispatch();
  const { isSaving } = useSelector((state) => state.categoryReducer);

  const handleDelete = async () => {
    const result = await dispatch(deleteCategory(category?.id));
    if (result?.ok) {
      dispatch(getCategories({ page: (page ?? 0) + 1, rowsPerPage: rowsPerPage ?? 10 }));
      handleClose(true);
    }
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Delete {category?.name || 'this category'}?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>Code {category?.class_code || '—'}.</DialogContentText>
        <Alert severity="info">
          A category still used by assets or sub categories cannot be deleted; reassign them first.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={() => handleClose(false)}>
          Cancel
        </Button>
        <LoadingButton size="small" color="error" variant="contained" loading={isSaving} onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
